/**
 * Quote Service
 * Handles API calls for quote requests and bookings
 */

import { apiClient } from './client';
import { Quote, QuoteRequest, BookQuoteRequest, BookingResponse } from '../../types/quote';
import { APIResponse } from './client';

class QuoteService {
  /**
   * Request quotes from counterparty(ies)
   */
  async requestQuote(request: QuoteRequest): Promise<Quote[]> {
    const response = await apiClient.post<{ quotes: Quote[] }>('/api/v1/quotes/request', request);

    if (!response.success || !response.data.quotes) {
      throw new Error(response.message || 'Failed to request quote');
    }

    return response.data.quotes;
  }

  /**
   * Book a trade using a quote ID
   */
  async bookQuote(request: BookQuoteRequest): Promise<BookingResponse> {
    const response = await apiClient.post<{ booking: BookingResponse }>('/api/v1/quotes/book', request);

    if (!response.success || !response.data.booking) {
      throw new Error(response.message || 'Failed to book quote');
    }

    return response.data.booking;
  }
}

// Export singleton instance
export const quoteService = new QuoteService();
